/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.morse_save_message = {
  init: function () {
    this.setColour(colors.COLOUR_MORSE);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MORSE_SAVE_MESSAGE);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MORSE_SAVE_MESSAGE_TOOLTIP);
  },
};

Blockly.Blocks.morse_decode_message = {
  init: function () {
    this.setColour(colors.COLOUR_MORSE);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MORSE_DECODE_MESSAGE);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MORSE_DECODE_MESSAGE_TOOLTIP);
  },
};

Blockly.Blocks.morse_get_message = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_MORSE);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MORSE_GET_MESSAGE);
    this.setInputsInline(true);
    this.setOutput(true, 'Number');
    this.setTooltip(Blockly.Msg.LANG_MORSE_GET_MESSAGE_TOOLTIP);
  },
};
